export const getSignature = async (message: string) => {
  if (!window.crypto?.subtle) {
    const sha1 = await import(/* webpackChunkName: 'crypto-sha1' */ 'crypto-js/sha1');
    return sha1.default(message).toString();
  }

  const msgUint8 = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-1', msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((num) => num.toString(16).padStart(2, '0')).join('');
};
